import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers-latest';
import {
  Controller,
  type ControllerProps,
  type FieldPath,
  type FieldValues,
} from 'react-hook-form';

interface DateTimePickerControllerProps<
  TDate,
  // controller generics
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> extends Omit<ControllerProps<TFieldValues, TName>, 'render'>,
    Omit<Partial<DateTimePickerProps<TDate>>, 'defaultValue' | 'name'> {}

export const DateTimePickerController = <
  TDate,
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: DateTimePickerControllerProps<TDate, TFieldValues, TName>,
) => {
  const { name, control, defaultValue, disabled, rules, shouldUnregister, ...pickerProps } = props;
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      disabled={disabled}
      rules={rules}
      shouldUnregister={shouldUnregister}
      render={({ field, fieldState }) => (
        <DateTimePicker
          {...field}
          value={field.value}
          {...pickerProps}
          slotProps={{
            ...pickerProps?.slotProps,
            textField: {
              helperText: fieldState.error?.message,
              ...pickerProps.slotProps?.textField,
            },
          }}
        />
      )}
    />
  );
};
